import Vue from 'vue'
import Vuetify from 'vuetify/lib'

import App from './App.vue'
import vuetify from './plugins/vuetify';

import router from './router';

import VueGtag from "vue-gtag";
import Adsense from 'vue-google-adsense/dist/Adsense.min.js'

Vue.use(require('vue-script2'))
Vue.use(Adsense)

Vue.use(VueGtag, {
  config: { id: "UA-154970948-1" },
}, router);

Vue.use(Vuetify)
// Vue.config.productionTip = false
// Vue.config.silent = true

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
